import React, { ReactNode } from 'react'

import Tooltip from '../TooltipInfo/Tooltip'

import classes from './styles.module.scss'

interface Props {
  title: string
  tooltipText: string
  children: ReactNode
  totalUsers?: number
  activeUsers?: number
  button?: ReactNode
}

const DashboardContainer: React.FC<Props> = ({ title, tooltipText, children, activeUsers, totalUsers, button }) => {
  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <span className={classes.titleWrapper}>
          <div className={`${classes.text} ${classes.title}`}>
            {title}
            {tooltipText && <Tooltip tooltipId={'TooltipInfo-attribute'} tooltipText={tooltipText} />}
          </div>
          {button}
        </span>
        {!!totalUsers && !!activeUsers && (
          <div>
            <span className={classes.statsText}>Active users</span>
            <span className={classes.statsNumber}>{activeUsers}</span>
            <span className={classes.statsText}>Total users</span>
            <span className={classes.statsNumber}>{totalUsers}</span>
          </div>
        )}
      </div>
      {children}
    </div>
  )
}

export default DashboardContainer
